function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "74",
  height: "87",
  viewBox: "0 0 74 87"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
  id: "5zkuxqiszd",
  cx: "22",
  cy: "22.154",
  rx: "18.7",
  ry: "18.831"
}), /*#__PURE__*/React.createElement("filter", {
  id: "hpf5gwnvka",
  width: "160.6%",
  height: "155.6%",
  x: "-30.3%",
  y: "-27.8%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: "5"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1",
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "SourceGraphic"
}))), /*#__PURE__*/React.createElement("path", {
  id: "0fzllflfwb",
  d: "M40.234 34.558C42.628 31.098 44 26.611 44 22.154 44 9.919 34.15 0 22 0S0 9.919 0 22.154c0 4.3.964 8.599 3.322 12.404C4.895 37.095 11.12 44.038 22 55.385c10.56-11.578 16.638-18.52 18.234-20.827z"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#hpf5gwnvka)",
  transform: "translate(4 8)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(11 7.754)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "8secxtz6kc",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#0fzllflfwb"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#FABE28",
  xlinkHref: "#0fzllflfwb"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#999",
  mask: "url(#8secxtz6kc)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h44v55.385H0z"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#5zkuxqiszd"
})))));